import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Squircle from 'design-system/Squircle';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
const CategoryHeaderComponent = ({ name, total = 0, description, ...props }) => {
    const renderGraphics = () => {
        if ('emoji' in props) {
            return <Text Text-20>{props.emoji}</Text>;
        }
        if ('Icon' in props) {
            // Removing icons for now
            const { Icon } = props;
            return Icon ? <Icon /> : null;
        }
        return null;
    };
    const renderCount = useCallback(() => {
        if ('emoji' in props) {
            return `${total} ${total === 1 ? 'item' : 'items'}`;
        }
        return `${total} ${total === 1 ? 'Company' : 'Companies'}`;
    }, [props, total]);
    const colors = useColors();
    return (<View style={styles.listHeaderContainer}>
      <View style={styles.infoContainer}>
        <Text Text-32>{name}</Text>
        <Text Text-14 Secondary>
          {renderCount()}
        </Text>
        {!!description && (<>
            <Spacer h={rem(4)}/>
            <Text TextThin-14 Secondary>
              {description}
            </Text>
          </>)}
      </View>
      {('emoji' in props && props.emoji) || ('Icon' in props && props.Icon) ? (<>
          <Spacer w={16}/>
          <View style={styles.iconWrapper}>
            <Squircle width={rem(44)} height={rem(44)} color={colors.cards.onDark}>
              {renderGraphics()}
            </Squircle>
          </View>
        </>) : null}
    </View>);
};
const styles = StyleSheet.create({
    listHeaderContainer: {
        flexDirection: 'row',
        paddingBottom: rem(24),
        paddingHorizontal: rem(16),
    },
    infoContainer: {
        flex: 1,
    },
    iconWrapper: {
        justifyContent: 'center',
    },
});
export default React.memo(CategoryHeaderComponent);
